import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { Credentials } from "auth";
import { State } from "redux/state";

import { Coupon } from "@xapp/stentor-api-client/dist/api/plans/coupons/Coupons";

export type GetCoupon = "GET_COUPON";
export const GET_COUPON: GetCoupon = "GET_COUPON";
export type GetCouponEnd = "GET_COUPON_END";
export const GET_COUPON_END: GetCouponEnd = "GET_COUPON_END";

export interface GetCouponAction extends Action {
    payload: {
        couponCode: string;
        credentials: Credentials;
        plan?: string;
    };
    type: GetCoupon;
}

export function getCoupon(couponCode: string, plan?: string): ThunkAction<any, State, any, GetCouponAction> {
    return (dispatch: Dispatch<GetCouponAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(getCouponWithCredentials(couponCode, credentials, plan));
    };
}

export function getCouponWithCredentials(couponCode: string, credentials: Credentials, plan?: string): GetCouponAction {
    return {
        payload: { couponCode, credentials, plan },
        type: GET_COUPON
    };
}

export interface GetCouponEndAction {
    payload: {
        coupon?: Coupon;
        error?: Error;
    };
    type: GetCouponEnd;
}

export function getCouponEnd(error?: Error, coupon?: Coupon): GetCouponEndAction {
    return {
        payload: { coupon, error },
        type: GET_COUPON_END
    };
}
